import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2, X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const useSelection = (items, key = "id") => {
  const [sel, setSel] = useState(() => new Set());
  const visible = useMemo(() => items.map((i) => i[key]), [items, key]);
  const ids = visible.filter((id) => sel.has(id));
  const all = visible.length > 0 && ids.length === visible.length;
  return {
    ids, all, has: (id) => sel.has(id),
    toggle: (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; }),
    toggleAll: () => setSel(all ? new Set() : new Set(visible)),
    clear: () => setSel(new Set()),
  };
};

export const CheckAll = ({ s, testid }) => (
  <input type="checkbox" checked={s.all} onChange={s.toggleAll} aria-label="Seleziona tutti" className="h-4 w-4 accent-amber-500" data-testid={testid} />
);

export const Check = ({ s, id, testid }) => (
  <input type="checkbox" checked={s.has(id)} onChange={() => s.toggle(id)} onClick={(e) => e.stopPropagation()} aria-label="Seleziona" className="h-4 w-4 accent-amber-500" data-testid={testid} />
);

export const runBulk = async (path, body, label) => {
  try {
    const { data } = await api.post(path, body);
    if (data.done) toast.success(`${label}: ${data.done} ${data.done === 1 ? "elemento" : "elementi"}`);
    if (data.errors?.length) toast.warning(data.errors.slice(0, 6).join("\n") + (data.errors.length > 6 ? `\n…e altri ${data.errors.length - 6}` : ""), { duration: 9000 });
    if (data.info) toast.info(data.info);
    if (!data.done && !data.errors?.length && !data.info) toast.info("Nessuna modifica");
    return data;
  } catch (err) {
    toast.error(formatApiError(err));
    return null;
  }
};

export const exportXlsx = async (entity, ids) => {
  try {
    const res = await api.post(`/admin/bulk/${entity}/export`, { ids }, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = Object.assign(document.createElement("a"), { href: url, download: `cardsource-${entity}.xlsx` });
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    toast.error(formatApiError(err));
  }
};

export const confirmDelete = (n, what = "elementi") => window.confirm(`Eliminare ${n} ${what}? L'operazione non si può annullare.`);

export const BulkBar = ({ s, entity, onDelete, children, prefix }) => {
  if (!s.ids.length) return null;
  return (
    <div className="sticky top-2 z-20 mb-3 flex flex-wrap items-center gap-2 rounded-2xl border-2 border-black bg-amber-100 px-4 py-2 text-sm shadow-[3px_3px_0_#000]" data-testid={`${prefix}-bulk-bar`}>
      <b data-testid={`${prefix}-bulk-count`}>{s.ids.length} selezionati</b>
      {children}
      <button onClick={() => exportXlsx(entity, s.ids)} className="flex items-center gap-1 rounded-full border border-black/30 bg-white px-3 py-1" data-testid={`${prefix}-bulk-export`}><Download className="h-3.5 w-3.5" />Esporta Excel</button>
      {onDelete && <button onClick={onDelete} className="flex items-center gap-1 rounded-full border border-rose-400 bg-white px-3 py-1 text-rose-600" data-testid={`${prefix}-bulk-delete`}><Trash2 className="h-3.5 w-3.5" />Elimina</button>}
      <button onClick={s.clear} className="ml-auto flex items-center gap-1 text-stone-600" data-testid={`${prefix}-bulk-clear`}><X className="h-4 w-4" />Deseleziona</button>
    </div>
  );
};

export const bulkInp = "h-8 rounded-lg border border-black/20 bg-white px-2 text-xs";
